import React from "react";

export const Logo = ({ compact = false, className = "" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <div className="relative flex h-10 w-10 items-center justify-center rounded-full border border-gold/60 bg-obsidian-800 shadow-[0_0_18px_rgba(212,175,55,0.25)]">
        <span className="font-display text-lg font-bold gold-text">AM</span>
      </div>
      {!compact && (
        <div className="leading-none">
          <div className="font-display text-lg font-bold tracking-wide text-white">ALI MALAK</div>
          <div className="font-mono text-[9px] uppercase tracking-[0.35em] text-gold">Barbershop</div>
        </div>
      )}
    </div>
  );
};
